import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  Card,
  Skeleton,
  Avatar,
  Space,
  PageHeader,
  Button,
  Popconfirm,
  Radio,
} from 'antd';
import { withRouter } from 'react-router-dom';
import { getEnabledSkills } from './Apphomeutils';
import './Apphome.css';
import ManagePages from './ManagePages/ManagePages.jsx';
import ManageActions from './ManageActions/ManageActions';
import ManageContent from './MangeContent/ManageContent';
import ManageFooter from './ManageFooter/ManageFooter';
import {
  getApphomeConfig,
  resetApphome,
  switchBetweenUserAndWorkspace,
} from './ApphomeActions';
import { Spin } from 'antd';
import queryString from 'query-string';

const { Meta } = Card;
const Apphome = (props) => {
  const isPersonalApphome = props.isPersonalApphome ? true : false;
  const { isAdminApphome, hasWikiSkill } = props;
  const isDarkTheme = localStorage.getItem('theme') == 'dark' ? true : false;
  const isAdmin = useSelector((state) => state.common_reducer.isAdmin);
  const dispatch = useDispatch();
  const skills = useSelector((state) => state.skills.skills);
  const apphome = useSelector((state) => state.apphome.apphome);
  const [showNotAnAdminError, setShowNotAnAdminError] = useState(false);
  const [enabledSkills, setEnabledSkills] = useState([]);
  const [pageView, setPageView] = useState('');
  const [pages, setPages] = useState([]);
  const [loading, setLoading] = useState(false);
  const hideCustomizeButtons =
    apphome && apphome.isWorkspaceApphome && isPersonalApphome ? true : false;
  const pageInfo =
    apphome &&
    apphome.pages &&
    apphome.pages.find((page) => page._id === (apphome && apphome.pageView));
  const pageViewType = pageInfo && pageInfo.pageViewType;
  useEffect(() => {
    const enabledSkills = getEnabledSkills(skills || []);
    setEnabledSkills(enabledSkills);
  }, [skills]);

  useEffect(() => {
    setPages(apphome.pages);
    setPageView(apphome.pageView);
  }, [apphome]);
  useEffect(() => {
    if (isAdminApphome && !isAdmin) {
      setShowNotAnAdminError(true);
    } else {
      setShowNotAnAdminError(false);
    }
  }, [isAdmin]);
  useEffect(() => {
    setLoading(true);
    (async () => {
      await dispatch(
        getApphomeConfig(props.match.params.wId, isPersonalApphome)
      );
      setLoading(false);
    })();
  }, []);
  const resetToDefaults = async () => {
    dispatch(resetApphome(props.match.params.wId, apphome._id));
  };
  const changeToUserOrWorkspace = (event) => {
    dispatch(
      switchBetweenUserAndWorkspace(props.match.params.wId, apphome._id, {
        useWorkspaceApphome: event.target.value === 'workspace' ? true : false,
      })
    );
  };
  return (
    <div className='apphome_container' style={{ width: '100%' }}>
      {loading ? (
        <Spin
          style={{
            height: '100vh',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        />
      ) : showNotAnAdminError ? (
        <h1
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          {' '}
          Admin access required
        </h1>
      ) : (
        <>
          {isPersonalApphome && (
            <PageHeader
              style={{
                margin: '10px 0px',
                padding: '0px 24px',
                height: `5vh`,
              }}
              title='My Slack Apphome'
              subTitle='Setup personal apphome for Slack'
            ></PageHeader>
          )}
          <div
            style={{
              minHeight: `${isPersonalApphome ? '92vh' : '84vh'}`,
              overflowY: 'auto',
              height: `${
                isPersonalApphome ? '92vh' : hasWikiSkill ? '84vh' : '100%'
              }`,
              padding: `${isPersonalApphome ? '0px 32px' : '0px'}`,
            }}
          >
            <Card
              className='card-extra-no-padding'
              title='Customize App home'
              headStyle={{ padding: 0, margin: 0 }}
              bordered={false}
              bodyStyle={{
                padding: 0,
                margin: 0,
              }}
              extra={
                isPersonalApphome ? (
                  <div>
                    {' '}
                    <Radio.Group
                      value={
                        apphome && apphome.useWorkspaceApphome
                          ? 'workspace'
                          : 'personal'
                      }
                      onChange={(event) => changeToUserOrWorkspace(event)}
                    >
                      <Radio value='personal'>Personalize apphome</Radio>
                      <Radio value='workspace'>Use workspace default</Radio>
                    </Radio.Group>
                  </div>
                ) : (
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'flex-end',
                      padding: '0px',
                      margin: '0px',
                      paddingRight: '16px',
                    }}
                  >
                    <Popconfirm
                      placement='left'
                      title='Are you sure to reset to defaults?'
                      onConfirm={resetToDefaults}
                      okText='Yes'
                      cancelText='No'
                    >
                      <Button>Reset</Button>
                    </Popconfirm>
                  </div>
                )
              }
            >
              {isPersonalApphome && (
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    paddingTop: '10px',
                    paddingRight: '16px',
                  }}
                >
                  <Popconfirm
                    disabled={
                      isPersonalApphome && apphome && apphome.isWorkspaceApphome
                    }
                    placement='left'
                    title='Are you sure to reset to defaults?'
                    onConfirm={resetToDefaults}
                    okText='Yes'
                    cancelText='No'
                  >
                    <Button
                      disabled={
                        isPersonalApphome &&
                        apphome &&
                        apphome.isWorkspaceApphome
                      }
                    >
                      Reset
                    </Button>
                  </Popconfirm>
                </div>
              )}

              <div
                style={{
                  // marginTop: `${isPersonalApphome ? '0px' : '16px'}`,
                  background: `${isDarkTheme ? '' : '#FFFFFF'}`,
                  border: `${isDarkTheme ? '' : '1px solid #F0F0F0'}`,
                }}
                className='apphome_inner_container'
              >
                <div style={{ display: 'flex' }}>
                  <div>
                    <Card
                      style={{
                        width: '154px',
                        background: '#552456',
                        padding: 0,
                        margin: 0,
                        height: '100%',
                        borderTopLeftRadius: '8px',
                        borderBottomLeftRadius: '8px',
                      }}
                      // bodyStyle={{ padding: 24 }}
                    >
                      <Space>
                        <Skeleton.Avatar
                          active={true}
                          shape='square'
                        ></Skeleton.Avatar>
                      </Space>
                      <div>&nbsp;</div>
                      <Skeleton
                        title={false}
                        paragraph={{ rows: 4 }}
                        active={true}
                        loading={true}
                      ></Skeleton>
                      <Skeleton
                        title={false}
                        paragraph={{ rows: 4 }}
                        active={true}
                        loading={true}
                      ></Skeleton>
                      <Skeleton
                        title={false}
                        paragraph={{ rows: 4 }}
                        active={true}
                        loading={true}
                      ></Skeleton>
                      <Skeleton
                        title={false}
                        paragraph={{ rows: 4 }}
                        active={true}
                        loading={true}
                      ></Skeleton>
                    </Card>
                  </div>

                  <div style={{ padding: '8px 24px', width: '100%' }}>
                    <div className='apphome_header'>
                      <div className='apphome_header_logo_title_section'>
                        <span className='apphome_header_logo '>
                          <img
                            src='/favicon-32x32.png'
                            alt='logo'
                            id='app-logo-card'
                          />
                        </span>
                        <span className='apphome_header_title'>
                          Troopr Assistant
                        </span>
                      </div>
                      <div className='app_home_header_home_tab_container'>
                        <div className='app_home_header_home_tab'>Home</div>
                      </div>
                    </div>
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        height: '520px',
                        justifyContent: 'space-between',
                      }}
                    >
                      <div>
                        <ManagePages
                          hideCustomizeButtons={hideCustomizeButtons}
                          pages={pages}
                          setPages={setPages}
                          enabledSkills={enabledSkills}
                          pageView={pageView}
                          setPageView={setPageView}
                          apphome={apphome}
                        />
                        <ManageActions
                          hideCustomizeButtons={hideCustomizeButtons}
                          apphome={apphome}
                          pageViewType={pageViewType}
                          isPersonalApphome={isPersonalApphome}
                        />
                        <ManageContent
                          hideCustomizeButtons={hideCustomizeButtons}
                          isPersonalApphome={isPersonalApphome}
                          apphome={apphome}
                          pageViewType={pageViewType}
                        />
                      </div>
                      <div>
                        <ManageFooter
                          apphome={apphome}
                          pageViewType={pageViewType}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Card>
          </div>
        </>
      )}
    </div>
  );
};

export default withRouter(Apphome);
